// import AvenirRegularWoff2 from './721263/2cd55546-ec00-4af9-aeca-4a3cd186da53.woff2'
import AvenirMediumWoff2 from './721275/627fbb5a-3bae-4cd9-b617-2f923e29d55e.woff2'
import AvenirSemiBoldWoff2 from './721269/aad99a1f-7917-4dd6-bbb5-b07cedbff64f.woff2'
import AvenirBoldWoff2 from './721281/14c73713-e4df-4dba-933b-057feeac8dd1.woff2'

export const avenirMedium = {
  fontFamily: 'AvenirNextLTW01-Medium',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 500,
  src: `
    local('Avenir Next'),
    url(${AvenirMediumWoff2}) format('woff2')
  `,
}

export const avenirSemiBold = {
  fontFamily: 'Avenir Next LT W01 Demi',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 600,
  src: `
    local('Avenir Next'),
    url(${AvenirSemiBoldWoff2}) format('woff2')
  `,
}

export const avenirBold = {
  fontFamily: 'Avenir Next LT W01 Bold',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    local('Avenir Next'),
    url(${AvenirBoldWoff2}) format('woff2')
  `,
}
